import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

export const Eyebrow = ({ children, className = "" }) => (
  <span className={`eyebrow ${className}`}>
    <span className="h-1.5 w-1.5 rounded-full bg-primary" />
    {children}
  </span>
);

export const SectionHeading = ({ eyebrow, title, intro, align = "left", className = "" }) => (
  <div className={`${align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"} ${className}`}>
    {eyebrow && <Eyebrow className={align === "center" ? "justify-center" : ""}>{eyebrow}</Eyebrow>}
    <h2 className="mt-4 font-display text-3xl font-semibold tracking-tight sm:text-4xl">{title}</h2>
    {intro && <p className="mt-4 text-base leading-relaxed text-muted-foreground">{intro}</p>}
  </div>
);

// A simple link styled with an arrow, used for "next action" links.
export const ArrowLink = ({ to, children, testid, onClick }) => {
  const cls = "group inline-flex items-center gap-2 text-sm font-medium text-foreground hover:text-primary transition-colors";
  const inner = (
    <>
      {children}
      <span className="transition-transform duration-200 group-hover:translate-x-1">→</span>
    </>
  );
  if (onClick) return <button onClick={onClick} data-testid={testid} className={cls}>{inner}</button>;
  return <Link to={to} data-testid={testid} className={cls}>{inner}</Link>;
};

export const Section = ({ children, className = "", id }) => (
  <section id={id} className={`ytca-section ${className}`}>
    <div className="ytca-container">
      <Reveal>{children}</Reveal>
    </div>
  </section>
);
